import { InputBase, type InputBaseProps, styled } from '@mui/material';
import { forwardRef } from 'react';
import type { ICardProps } from '@/common/components/ui/swimlane/types';

export type AddSubItemInputProps = ICardProps & InputBaseProps;

export const AddSubItemInput = forwardRef(
  ({ itemID, rowID, columnID, ...props }: AddSubItemInputProps, ref) => (
    <StyledInput
      data-no-dnd="true"
      fullWidth
      margin="none"
      placeholder="Enter a sub-item name"
      ref={ref}
      {...props}
      autoFocus
    />
  ),
);

const StyledInput = styled(InputBase)(({ theme }) => ({
  padding: '4px 10px',
  height: '28px',
  borderRadius: '4px',
  fontSize: '12px',
  border: `1px solid ${theme.palette.divider}`,
}));
